(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('admiral-lookbook')) {
    customElements.define(
      'admiral-lookbook',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-viewport]');
          this.track = this.querySelector('[data-track]');
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.previousButton = this.querySelector('[data-previous]');
          this.nextButton = this.querySelector('[data-next]');
          this.currentLabel = this.querySelector('[data-current]');
          this.progress = this.querySelector('[data-progress]');
          this.index = 0;
          this.startX = 0;
          this.deltaX = 0;
          this.resizeObserver = new ResizeObserver(() => this.updatePosition(false));

          if (!this.viewport || this.slides.length === 0) return;

          this.previousButton.addEventListener('click', () => this.goTo(this.index - 1));
          this.nextButton.addEventListener('click', () => this.goTo(this.index + 1));
          this.viewport.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
            if (event.key === 'ArrowRight') this.goTo(this.index + 1);
          });
          this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event));
          this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event));
          this.viewport.addEventListener('pointerup', () => this.onPointerUp());
          this.viewport.addEventListener('pointercancel', () => this.onPointerUp());
          this.resizeObserver.observe(this.viewport);

          this.goTo(0, false);
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        onPointerDown(event) {
          this.startX = event.clientX;
          this.deltaX = 0;
          this.viewport.setPointerCapture(event.pointerId);
        }

        onPointerMove(event) {
          if (!this.viewport.hasPointerCapture(event.pointerId)) return;
          this.deltaX = event.clientX - this.startX;
        }

        onPointerUp() {
          if (Math.abs(this.deltaX) > 45) {
            this.goTo(this.index + (this.deltaX < 0 ? 1 : -1));
          }
          this.deltaX = 0;
        }

        goTo(nextIndex, animate = true) {
          this.index = Math.max(0, Math.min(nextIndex, this.slides.length - 1));
          if (!animate) this.track.style.transition = 'none';
          this.updatePosition(animate);
          this.slides.forEach((slide, index) => {
            const active = index === this.index;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
          this.previousButton.disabled = this.index === 0;
          this.nextButton.disabled = this.index === this.slides.length - 1;
          this.currentLabel.textContent = String(this.index + 1).padStart(2, '0');
          this.progress.style.transform = `scaleX(${(this.index + 1) / this.slides.length})`;
          if (!animate) requestAnimationFrame(() => this.track.style.removeProperty('transition'));
        }

        updatePosition(animate = true) {
          if (!this.track || !this.viewport || !this.slides[this.index]) return;
          if (!animate) this.track.style.transition = 'none';
          const maximum = Math.max(0, this.track.scrollWidth - this.viewport.clientWidth);
          const offset = Math.min(this.slides[this.index].offsetLeft, maximum);
          this.track.style.transform = `translate3d(-${offset}px, 0, 0)`;
          if (!animate) requestAnimationFrame(() => this.track.style.removeProperty('transition'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
